"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveControlsManager = void 0;
var MoveControlsManager = /** @class */ (function () {
    function MoveControlsManager(player, logger, upperBarManager, redux) {
        this.player = player;
        this.logger = logger;
        this.store = redux.useStore();
        this.upperBarManager = upperBarManager;
        this.store.subscribe(this.handleStoreChange.bind(this));
        this.currentState = this.store.getState();
        this.iconIds = new Map();
    }
    Object.defineProperty(MoveControlsManager.prototype, "bottomBarRegistryManager", {
        get: function () {
            return this.player.getService('bottomBarRegistryManager') || undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MoveControlsManager.prototype, "state", {
        get: function () {
            return this.store.getState();
        },
        enumerable: false,
        configurable: true
    });
    MoveControlsManager.prototype.handleStoreChange = function () {
        var _this = this;
        var newState = this.state;
        var bottomBarRegistryManager = this.bottomBarRegistryManager;
        if (bottomBarRegistryManager && this.currentState.bottomBar !== newState.bottomBar) {
            this.logger.debug('Removing core controls from upper bar');
            // remove all the core icons and clear map
            __spreadArray([], __read(this.iconIds.values()), false).forEach(function (iconId) { return _this.upperBarManager.remove(iconId); });
            this.iconIds.clear();
            var controlsToMove = newState.bottomBar.controlsToMove;
            if (controlsToMove.length > 0) {
                this.logger.debug('Adding core controls to upper bar: ', controlsToMove);
                controlsToMove.forEach(function (componentName) {
                    var componentToMove = bottomBarRegistryManager.getComponentItem(componentName);
                    if (componentToMove) {
                        var iconId = _this.upperBarManager.add(componentToMove);
                        if (typeof iconId === 'number') {
                            _this.iconIds.set(componentName, iconId);
                        }
                    }
                });
            }
            this.currentState = newState;
        }
    };
    return MoveControlsManager;
}());
exports.MoveControlsManager = MoveControlsManager;
